import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { MAINTENANCE_CHECK_BASE_URL } from '@campus/browser';
import {
  AuthService,
  AUTH_SERVICE,
  GRECAPTCHA_TOKEN,
  PersonApi,
  PORTAL_ENVIRONMENT_TOKEN,
} from '@campus/public-portal';
import { environment } from '../environments/environment';
import { PersistedUsersService } from './services/persisted-users.service';

@NgModule({
  providers: [
    PersistedUsersService,
    provideAppInitializer(() => {
        const initializerFn = ((authService: PersonApi) => () => authService.getCurrent().toPromise())(inject(PersonApi));
        return initializerFn();
      }),
    {
      provide: AUTH_SERVICE,
      useClass: AuthService,
    },
    {
      provide: PORTAL_ENVIRONMENT_TOKEN,
      useValue: environment,
    },
    {
      provide: MAINTENANCE_CHECK_BASE_URL,
      useValue: '/',
    },
    {
      provide: GRECAPTCHA_TOKEN,
      useFactory: () => {
        return window['grecaptcha'] as ReCaptchaV2.ReCaptcha; // google recaptcha script is loaded in index.html
      },
    },
  ],
})
export class AppTokenModule {}
